import React from 'react';
import { FaPlane } from 'react-icons/fa';

const Logo: React.FC = () => {
  return (
    <div className="logo-container">
      <FaPlane className="logo-icon" />
      <div className="logo-text">
        <span className="logo-trip">Trip</span>
        <span className="logo-go">Go</span>
      </div>
    </div>
  );
};

export default Logo;